import { html } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import BaseBanner from './base-banner';

export default class BaseBannerMultiple extends BaseBanner {
  renderMultipleContentTexts(
    primaryTitle = '',
    secondaryTitle = '',
    bannerVolanta = '',
    bannerCta = '',
    bannerLegal = '',
    cardTextColor = '',
    cardBackgroundColor = '',
    classNamePrefix = 'adn',
    flatChevron = false,
  ) {
    const volanta = html`<p class="${classNamePrefix}-text-volanta">${bannerVolanta}</p>`;
    const legal = html`<p class="${classNamePrefix}-text-legal">${bannerLegal}</p>`;

    const cta = html`
  <div class="${classNamePrefix}-cta ${bannerVolanta ? 'with-volanta' : 'without-volanta'}">
    ${bannerCta && html`
      <p class="${classNamePrefix}-text-cta">${bannerCta}</p>
      ${this.renderChevron(flatChevron, cardTextColor)}
    `}
  </div>
`;

    return html`
      <div
        class="${classNamePrefix}-container-texts"
        style=${styleMap({
    color: cardTextColor,
    background: cardBackgroundColor,
  })}
      >
        <div id="father-titles" class=${bannerVolanta ? 'with-volanta' : ''}>
          ${bannerVolanta ? volanta : html``}
          <p class="${classNamePrefix}-text-title ${classNamePrefix}-text-format">${primaryTitle}</p>
          <p class="${classNamePrefix}-text-title ${classNamePrefix}-text-format">${secondaryTitle}</p>
        </div>
        ${bannerLegal ? legal : cta}
      </div>
    `;
  }

  renderMultipleLogos(primary_logo = '', secondary_logo = '', classNamePrefix = 'adn') {
    const primaryLogo = this.primary_logo || primary_logo;
    const secondaryLogo = this.secondary_logo || secondary_logo;

    return html`
      ${primaryLogo || secondaryLogo
    ? html`
            <div class="${classNamePrefix}-container-logo">
              <div class="${classNamePrefix}-position-logo">
                ${primaryLogo ? this.renderImage(`${classNamePrefix}-logo`, primaryLogo) : ''}
                ${secondaryLogo ? this.renderImage(`${classNamePrefix}-logo`, secondaryLogo) : ''}
              </div>
            </div>
          `
    : ''}
    `;
  }
}
